import _ from "underscore";
import ActionLogger from "action-logger";
import ActionTypes from "actions/action-types";
import { usdPriceIntoInt } from "helpers/PricingHelper";
import { sendSailthruPdpEvent, sendSailthruPdpPageView } from "helpers/third-party/sailthru-helpers.js";
import MembershipHelpers from "helpers/membership-helpers";

const logTypeList = [ActionTypes.PDP_PAGE_VIEW];

const exported = {
  log: function (log_type) {
    return function (dispatch, getState) {
      if (!_.contains(logTypeList, log_type)) {
        return;
      }

      const state = getState();
      let data;

      switch (log_type) {
        case ActionTypes.PDP_PAGE_VIEW: {
          const { product, reservation = {} } = state;

          data = {
            action: "view",
            objectType: "node",
            numReviews: state.reviews.count,
            priceMin: product.price?.minimum,
            priceMax: product.price?.maximum,
            retailPrice: usdPriceIntoInt(product?.retailPrice),
            styleName: product.id,
            prod_type: product.legacyProductType,
            average_rating: state.reviews.averageRating,
          };

          if (reservation?.zipCode) {
            data.zip = reservation.zipCode;
          }

          if (reservation?.date) {
            data.rentBegin = reservation.date;
          }

          if (reservation?.primarySku) {
            data.psizeCanonical = reservation.primarySku.canonicalSize;
            data.psize = reservation.primarySku.size;
          }

          if (reservation?.backupSku) {
            data.bsizeCanonical = reservation.backupSku.canonicalSize;
            data.bsize = reservation.backupSku.size;
          }

          break;
        }
        default:
          return;
      }

      ActionLogger.logAction(data);
    };
  },

  pdpPageView: function () {
    return (_dispatch, getState) => {
      const { product, userData } = getState();
      sendSailthruPdpEvent(product, userData?.userProfile?.email, MembershipHelpers.getUserDataLens(userData));
    };
  },

  pdpDrawerPageView: function () {
    return (_dispatch, getState) => {
      const { product } = getState();
      if (product?.id) {
        sendSailthruPdpPageView(product.id);
      }
    };
  },
};

export default exported;

export const { log } = exported;
